import {
  ABROAD_BIRTH_PLACE_ID,
  APPROVED_AWAITING_COLLECTION,
  AWAITING_A_MEDICAL_REPORT,
  AWAITING_B_MEDICAL_REPORT,
  BEING_EDITED,
  CLIENT_SIDE,
  educationLevel,
  FINISHED,
  FOR_REJECT,
  gender,
  INITIAL_SUBMIT,
  ISSUING_NAUTICAL_PAPER_PURCHASE_REFERRAL_BLUE,
  ISSUING_NAUTICAL_PAPER_PURCHASE_REFERRAL_RED,
  ISSUING_NAUTICAL_PAPER_PURCHASE_REFERRAL_YELLOW,
  MEDICAL_A_DEGREE_REJECTION,
  NOONE_SIDE,
  reasonCopyNauticalTable,
  REJECTED_FROM_CITIZEN,
  REJECTED_FROM_SERVICE,
  RESUBMITTED,
  retiredOptions,
} from "../../../constants";
import {
  CircularProgress,
  Grid,
  Link,
  Breadcrumbs as MuiBreadcrumbs,
  Card as MuiCard,
  Divider as MuiDivider,
  Typography,
  makeStyles,
} from "@material-ui/core";
import { Form, Formik } from "formik";
import {
  fetchApplicationWithId,
  updateApplicationStatusAndHistory,
  updateApplicationPortAuth,
} from "../../../services/applicationsService";
import { useMutation, useQuery } from "react-query";

import ApplicantDetails from "./ApplicantDetails";
import ApplicantDocuments from "./ApplicantDocuments";
import ApplicantReferrals from "./ApplicantReferrals/index";
import ApplicationHistory from "./ApplicationHistory";
import AppointmentModal from "./Appointment";
import CustomAlert from "../../components/CustomAlert";
import { Field } from "formik";

import { TextField as FormikTextField } from "formik-material-ui";
import { Helmet } from "react-helmet-async";
import MedicalAReportModal from "./MedicalAReportModal";
import MedicalBReportModal from "./MedicalBReportModal";
import { NavLink } from "react-router-dom";
import RejectionModal from "./RejectionModal";
import SectorModal from "./SectorModal";
import ls from "local-storage";
import dayjs from "dayjs";
import { fetchApplicationHistory } from "../../../services/applicationsHistory";
import { fetchApplicationStatus } from "../../../services/applicationStatusService";
import { fetchAvailableFlowStatutes } from "../../../services/flowApplicationStatusService";
import { spacing } from "@material-ui/system";
import styled from "styled-components/macro";
import { useHistory } from "react-router-dom";
import useLocale from "../../../hooks/useLocale";
import { useLocation } from "react-router-dom";
import { useRef, useState } from "react";
import PrintApplicationDetails from "./PrintApplicationDetails";
import GovGrCard from "../../../components/GovGrCard";
import GovGrTabs from "../../../components/GovGrTabs";
import GovGrButton from "../../../components/GovGrButton";
import GovGrSelectBox from "../../../components/GovGrSelectBox";
import { fetchPrfcsForExternalUser } from "../../../services/prfcsService";
import { fetchPortAuthoritiesForExternalUser } from "../../../services/portAuthoritiesService";
import GovGrTextField from "../../../components/GovGrTextField";
import GovGrTextArea from "../../../components/GovGrTextArea";
import GatewayDataDocuments from "./GatewayDataDocuments";
import { fetchBirthCountry } from "../../../services/birthCountryService";
import EParavoloBackOffice from "./eParavoloBackOffice";
import { useSelector } from "react-redux";
import { values } from "lodash";
import { fetchApplicationDocumentsExternalUser } from "../../../services/applicationDocuments";
// import UploadedDocuments from "../../../pages/external user/editApplication/UploadedDocuments";
import UploadedDocumentsAdmin from "./UploadedDocumentsAdmin";
import { documentsRequiredFiltered } from "../../../utils/nauticalPdcolorFn";
import { useEffect } from "react";
import { fetchDocPerSpecificKind } from "../../../services/documentsPerKindService";


const Divider = styled(MuiDivider)(spacing);
const Breadcrumbs = styled(MuiBreadcrumbs)(spacing);
const Card = styled(MuiCard)(spacing);

const useStyles = makeStyles((theme) => ({
  card: {
    display: "flex",
    flexDirection: "column",
    minWidth: 500,
    maxWidth: "100%",
    marginBottom: "1.2rem",
  },
  cardsSpace: {
    marginTop: 10,
    display: "flex",
    flexDirection: "column",
    justifyContent: "flex-start",
  },
  cardStatus: {
    display: "grid",
    justifyContent: "center",
  },
  commentInput: {
    width: "100%",
  },
  applicationCard: {
    maxWidth: "75vw",
  },
  loading: {
    display: "flex",
    justifyContent: "center",
    height: 400,
    alignItems: "center",
  },
  cardContent: {
    display: "inline-flex",
  },
  insideContentMargin: {
    marginRight: "2rem",
  },
  applyButton: {
    alignSelf: "center",
    minWidth: 150,
    maxWidth: 200,
    marginRight: "2rem",
  },
  rejectButton: {
    color: "red",
    alignSelf: "center",
    minWidth: 150,
    maxWidth: 200,
    marginRight: "2rem",
  },
  buttonArea: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
    marginTop: "2rem",
    width: "100%",
    minWidth: 500,
  },
  fieldArea: {
    display: "flex",
    flexDirection: "column",
  },
  waitingCard: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
    backgroundColor: "#F0E68C",
  },
  finishedCard: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
    backgroundColor: "#228B22",
  },
}));

const ApplicationEditPage = () => {
  const { t } = useLocale();
  const [activeTab, setActiveTab] = useState(0);
  const [isAppointmentModalOpen, setIsAppointmentModalOpen] = useState(false);
  const [isMedicalAReportOpen, setisMedicalAReportOpen] = useState(false);
  const [isMedicalBReportOpen, setisMedicalBReportOpen] = useState(false);
  const [isSectorModalOpen, setIsSectorModalOpen] = useState(false);
  const [isRejectionModalOpen, setIsRejectionModalOpen] = useState(false);
  const [error, setError] = useState("");
  const [success, setSuccess] = useState("");
  const formikRef = useRef();
  const auth_level = useSelector(
    (state) => state?.authReducer?.user?.auth_level
  );
  const [documentsFiltered, setDocumentsFiltered] = useState([]);

  let history = useHistory();

  const location = useLocation();
  const id = location?.state?.id;
  const viewOnly = location?.state?.viewOnly;

  const {
    data: applicationData,
    isLoading: isLoadingApplication,
    refetch: refetchApplication,
  } = useQuery(["application", id], () => fetchApplicationWithId(id));
  const classes = useStyles();

  const { data: docsPerKind } = useQuery(
    "docPerKindSpecificEdit",
    () => fetchDocPerSpecificKind(applicationData?.[0]?.appl_kind_id),
    {
      enabled: !!applicationData?.[0]?.appl_kind_id,
    }
  );

  useEffect(() => {
    // console.log("*******************");
    // console.log(id);
    if (applicationData?.length > 0) {
      setDocumentsFiltered(
        documentsRequiredFiltered(
          docsPerKind,
          applicationData?.[0]?.nautical_pd_color
        )
      );
    }
  }, [docsPerKind, applicationData]);

  const { data: availableStatusesData } = useQuery(
    [
      "availableFlowStatuses",
      applicationData?.[0]?.status,
      applicationData?.[0]?.appl_kind_id,
    ],
    () =>
      fetchAvailableFlowStatutes(
        applicationData?.[0]?.status,
        applicationData?.[0]?.appl_kind_id
      )
  );

  const { data: prfcsData } = useQuery("prfcs", fetchPrfcsForExternalUser);
  const { data: PortAuthoritiesData } = useQuery(
    "portAuthorities",
    fetchPortAuthoritiesForExternalUser
  );

  const { refetch: refetchApplicationHistory } = useQuery(
    ["applicationHistoryWithId", id],
    () => fetchApplicationHistory(id)
  );

  const { data: applicationStatus } = useQuery(
    "applicationStatus",
    fetchApplicationStatus
  );

  const {
    data: commentHistoryData,
    isError: isErrorCommentHistory,
    isLoading: isLoadingCommentHistory,
    refetch: refetchCommentHistory,
  } = useQuery(["applicationHistoryWithId", id], () =>
    fetchApplicationHistory(id)
  );

  const { data: fetchBirthCountries } = useQuery(
    "fetchBirthCountries",
    fetchBirthCountry
  );



  const { mutatepa } = useMutation(updateApplicationPortAuth, {
    onSuccess: (data, values, setFieldValues) => {
      const objWithStatus = JSON.parse(values?.items);
      refetchApplication();
      refetchApplicationHistory();
      setError("");
      setSuccess(t("Application status changed successfully"));
      setTimeout(() => {
        setSuccess("");
        let currentStatus = applicationStatus?.find(
          (status) => status.id === objWithStatus[0].application.status
        );

        if (
          currentStatus.is_service === CLIENT_SIDE ||
          currentStatus.is_service === NOONE_SIDE
        ) {
          history.push("/editApplications");
        }
      }, 3000);
    },
    onError: (error, values) => {
      switch (error) {
        default: {
          setError(t(error.response.data));
          const items = JSON.parse(values.items);
          // if there was an error in rejection reset medical a fields
          if (
            items[0].applicationHistory.new_status ===
            MEDICAL_A_DEGREE_REJECTION
          ) {
            formikRef.current.setFieldValue("a_medical_date", null);
            formikRef.current.setFieldValue("history_comment", "");
          }
        }
      }

    }
  });

  const { mutate } = useMutation(updateApplicationStatusAndHistory, {
    onSuccess: (data, values, setFieldValues) => {
      const objWithStatus = JSON.parse(values?.items);
      refetchApplication();
      refetchApplicationHistory();
      setError("");
      setSuccess(t("Application status changed successfully"));
      setTimeout(() => {
        setSuccess("");
        let currentStatus = applicationStatus?.find(
          (status) => status.id === objWithStatus[0].application.status
        );

        if (
          currentStatus.is_service === CLIENT_SIDE ||
          currentStatus.is_service === NOONE_SIDE
        ) {
          history.push("/editApplications");
        }
      }, 3000);
    },
    onError: (error, values) => {
      switch (error) {
        default: {
          setError(t(error.response.data));
          const items = JSON.parse(values.items);
          // if there was an error in rejection reset medical a fields
          if (
            items[0].applicationHistory.new_status ===
            MEDICAL_A_DEGREE_REJECTION
          ) {
            formikRef.current.setFieldValue("a_medical_date", null);
            formikRef.current.setFieldValue("history_comment", "");
          }
        }
      }
    },
  });

  const handleTabChange = (index) => {
    setActiveTab(index);
  };

  const handleUpdateItem = async (values, actions) => {
    let topos_eggrafis = "";
    if (values.place_birth_afora.id) {
      // Check if birth place !== ABROAD_BIRTH_PLACE_ID and put topos_eggrafis =null otherwise puts the value added by the user
      parseInt(values.place_birth_afora.id) !== ABROAD_BIRTH_PLACE_ID
        ? (topos_eggrafis = "")
        : (topos_eggrafis = values.topos_eggrafis_dimotologiou_ellada);
    } else {
      values.place_birth_afora !== ABROAD_BIRTH_PLACE_ID
        ? (topos_eggrafis = "")
        : (topos_eggrafis = values.topos_eggrafis_dimotologiou_ellada);
    }

    let valuesToSend = {
      application: {
        id: id,
        status: values.available_statuses.to_sts_id,
        rndv_from: values.rndv_from
          ? dayjs(values.rndv_from).format("YYYY-MM-DD")
          : null,
        // rndv_to: values.rndv_to
        //   ? dayjs(values.rndv_to).format("YYYY-MM-DD")
        //   : null,
        a_medical_date: values.a_medical_date
          ? dayjs(values.a_medical_date).format("YYYY-MM-DD")
          : null,
        b_medical_date: values.b_medical_date
          ? dayjs(values.b_medical_date).format("YYYY-MM-DD")
          : null,
      },
      applicationHistory: {
        appl_kind_id: values.appl_kind_id,
        appl_id: id,
        old_status: values.available_statuses.from_sts_id,
        new_status: values.available_statuses.to_sts_id,
        comments: values.history_comment,
      },
    };

    if (values.afm_afora === values.afm_ait) {
      valuesToSend.application = {
        ...valuesToSend.application,

        // application

        port_authority_id: values.port_authority_id,
        pickup_place_id: values.pickup_place?.id,
        appl_kind_id: values.appl_kind_id,
        appl_dt: dayjs(values.appl_dt, "DD/MM/YYYY").format("YYYY-MM-DD"),
        reg_num: values.reg_num,

        // applicant
        lname_ait: values.lname_afora,
        fname_ait: values.fname_afora,
        afm_ait: values.afm_afora,
        ind_nr_ait: values.ind_nr_afora,
        fath_lname_ait: values.fath_lname_afora,
        fath_fname_ait: values.fath_fname_afora,
        address_ait: values.address_afora,
        address_nr_ait: values.address_nr_afora,
        tk_ait: values.tk_afora,
        tel_ait: values.tel_afora,
        mobile_ait: values.mobile_afora,
        email_ait: values.email_afora,
        amka_ait: values.amka_afora,
        meth_ait: values.meth_ait,

        // person concerned with the application
        lname_afora: values.lname_afora,
        fname_afora: values.fname_afora,
        afm_afora: values.afm_afora,
        ind_nr_afora: values.ind_nr_afora,
        fath_lname_afora: values.fath_lname_afora,
        fath_fname_afora: values.fath_fname_afora,
        moth_lname_afora: values.moth_lname_afora,
        moth_fname_afora: values.moth_fname_afora,
        dt_birth_afora:
          dayjs(values.dt_birth_afora).format("YYYY-MM-DD") || null,
        place_birth_afora:
          values.place_birth_afora?.id || values.place_birth_afora || null,
        dimos_diamonis_afora:
          values.dimos_diamonis_afora?.id ||
          values.dimos_diamonis_afora ||
          null,
        address_afora: values.address_afora,
        address_nr_afora: values.address_nr_afora,
        tk_afora: values.tk_afora,
        tel_afora: values.tel_afora,
        mobile_afora: values.mobile_afora,
        email_afora: values.email_afora,
        amka_afora: values.amka_afora,
        meth_afora: values.meth_afora,
        sector_id: values.sector_id?.id || values.sector?.id,
        port_authority_id: values.portAuthorityApplicant?.id,
        sintaksiouxos_afora: parseInt(values.sintaksiouxos_afora),
        epipedo_ekpaideusis_afora: values.epipedo_ekpaideusis_afora?.id,
        topos_eggrafis_dimotologiou_ellada: topos_eggrafis,
        gender_afora: values.gender_afora?.id,
        nationality_afora: values.nationality_afora,
        reason_for_copy_nautical_issue: parseInt(
          values.reason_for_copy_nautical_issue
        ),
        birth_country_id: values?.birth_country?.id,
        birth_city_not_greece: values?.birth_city_not_greece || null,
        criminal_record_requestId:
          values?.place_birth_afora?.criminal_record_requestId,
      };
    } else {
      valuesToSend.application = {
        ...valuesToSend.application,
        // application

        port_authority_id: values.port_authority_id,
        pickup_place_id: values.pickup_place?.id,
        appl_kind_id: values.appl_kind_id,
        appl_dt: dayjs(values.appl_dt, "DD/MM/YYYY").format("YYYY-MM-DD"),
        reg_num: values.reg_num,

        // applicant
        lname_ait: values.lname_ait,
        fname_ait: values.fname_ait,
        afm_ait: values.afm_ait,
        ind_nr_ait: values.ind_nr_ait,
        fath_lname_ait: values.fath_lname_ait,
        fath_fname_ait: values.fath_fname_ait,
        address_ait: values.address_ait,
        address_nr_ait: values.address_nr_ait,
        tk_ait: values.tk_ait,
        tel_ait: values.tel_ait,
        mobile_ait: values.mobile_ait,
        email_ait: values.email_ait,
        amka_ait: values.amka_ait,
        meth_ait: values.meth_ait,

        // person concerned with the application
        lname_afora: values.lname_afora,
        fname_afora: values.fname_afora,
        afm_afora: values.afm_afora,
        ind_nr_afora: values.ind_nr_afora,
        fath_lname_afora: values.fath_lname_afora,
        fath_fname_afora: values.fath_fname_afora,
        moth_lname_afora: values.moth_lname_afora,
        moth_fname_afora: values.moth_fname_afora,
        dt_birth_afora:
          dayjs(values.dt_birth_afora).format("YYYY-MM-DD") || null,
        place_birth_afora:
          values.place_birth_afora?.id || values.place_birth_afora || null,
        dimos_diamonis_afora:
          values.dimos_diamonis_afora?.id ||
          values.dimos_diamonis_afora ||
          null,
        address_afora: values.address_afora,
        address_nr_afora: values.address_nr_afora,
        tk_afora: values.tk_afora,
        tel_afora: values.tel_afora,
        mobile_afora: values.mobile_afora,
        email_afora: values.email_afora,
        amka_afora: values.amka_afora,
        meth_afora: values.meth_afora,
        sector_id: values.sector_id?.id,
        port_authority_id: values.portAuthorityApplicant?.id,
        sintaksiouxos_afora: parseInt(values.sintaksiouxos_afora),
        epipedo_ekpaideusis_afora: values.epipedo_ekpaideusis_afora?.id,
        topos_eggrafis_dimotologiou_ellada: topos_eggrafis,
        gender_afora: values.gender_afora?.id,
        nationality_afora: values.nationality_afora,
        reason_for_copy_nautical_issue: parseInt(
          values.reason_for_copy_nautical_issue
        ),
        birth_country_id: values?.birth_country?.id,
        birth_city_not_greece: values?.birth_city_not_greece || null,
        criminal_record_requestId:
          values?.place_birth_afora?.criminal_record_requestId,
      };
    }

    mutate({ items: JSON.stringify([valuesToSend]) });
    actions.setFieldValue("available_statuses", null);
  };

  const updateportauth_ = async (values) => {
    const valuesToSend = {
      application: {
        id: id,
        port_authority_id: values.port_authority_id,
      },
      // applicationHistory: {
      //   appl_id: id,
      //   // port_authority_id: values.currentStatus,
      // },
    };
    // console.log(valuesToSend);
    // updateApplicationPortAuth(JSON.stringify([valuesToSend]))
    mutatepa({ items: JSON.stringify([valuesToSend]) });
    // console.log("updateportauth")
  }


  const handleRejectItem = async (values) => {
    const valuesToSend = {
      application: {
        id: id,
        status: REJECTED_FROM_SERVICE,
      },
      applicationHistory: {
        appl_kind_id: values.appl_kind_id,
        appl_id: id,
        old_status: values.currentStatus,
        new_status: REJECTED_FROM_SERVICE,
        comments: values.history_comment,
      },
    };

    mutate({ items: JSON.stringify([valuesToSend]) });
  };

  const updateApplicationStatus = (values, actions) => {
    handleUpdateItem(values, actions);
  };
  const rejectApplication = (values) => {
    handleRejectItem(values);
  };

  const TranslatedRetiredOptions = retiredOptions?.map((option) => ({
    ...option,
    dscr: t(`${option.dscr}`),
  }));

  const TranslatedEducationLevel = educationLevel?.map((option) => ({
    ...option,
    dscr: t(`${option.dscr}`),
  }));



  const updateportauth = () => {
    console.log("updateportauth!!")
    refetchApplication();
    refetchApplicationHistory();
    setError("");
    setSuccess(t("Application status changed successfully"));
    setTimeout(() => {
      setSuccess("");
    }, 3000);

  }

  const translatedGender = gender?.map((option) => ({
    ...option,
    dscr: t(`${option.dscr}`),
  }));

  let findReasonTranslated;
  if (applicationData) {
    const findReasonForCopyNauticalIssue = reasonCopyNauticalTable?.find(
      (option) =>
        option.id === applicationData?.[0]?.reason_for_copy_nautical_issue
    );
    findReasonTranslated = t(`${findReasonForCopyNauticalIssue?.dscr}`);
  }

  if (applicationData && applicationData?.[0]?.nautical_pd_color) {
    ls.set("nauticalPdColor", applicationData?.[0]?.nautical_pd_color);
  }

  // ******************************

  const { data: documents } = useQuery(
    ["applicationDocumentsWithIdExternalUser", id],
    () => fetchApplicationDocumentsExternalUser(id)
  );

  const showUploadedDocumentsAdmin = () => {

    if (documents.length > 0) {
      return (<UploadedDocumentsAdmin
        initiallyUploadedDocuments={documents}
        docsPerKind={documentsFiltered}
        status={applicationData?.[0]?.status}
        id={id}
        disableAll={false
          // applicationData?.[0]?.isService === SERVICE_SIDE ||
          // applicationData?.[0]?.isService === NOONE_SIDE
        }
      />)

    } else {
      return (<></>)
    }

  };

  // *****************************

  //TODO:HERE WE NEED TO CHECK THE NEW ROLE THAT CHECK PARAPEMPTIKA AND HIDE ALL TABS THAT ARE NOT PARAPEMPTIKA
  const tabs = [
    {
      id: 0,
      tabName: t("Applicant details"),
      component: (
        <ApplicantDetails
          key={0}
          rid={applicationData?.[0]?.id}
          values={formikRef?.current ? formikRef?.current?.values : null}
          touched={
            formikRef?.current?.touched ? formikRef?.current?.touched : null
          }
          errors={formikRef?.current ? formikRef?.current?.errors : null}
          disableAll={
            true
            // applicationData?.[0]?.status === INITIAL_SUBMIT ||
            // applicationData?.[0]?.status === RESUBMITTED ||
            // applicationData?.[0]?.isService === CLIENT_SIDE ||
            // applicationData?.[0]?.isService === NOONE_SIDE ||
            // viewOnly
          }
          updateportauth={updateportauth}
          translatedGender={translatedGender}
          currentStatus={applicationData?.[0]?.status}
        />
      ),
    },
    {
      id: 1,
      tabName: t("Documents"),
      component: (
        <ApplicantDocuments
          key={1}
          id={id}
          applicationKindId={applicationData?.[0]?.appl_kind_id}
          currentStatus={applicationData?.[0]?.status}
          viewOnly={viewOnly}
          nauticalPdColor={applicationData?.[0]?.nautical_pd_color}
        />
      ),
    },
    {
      id: 7,
      tabName: t("Pending Documents"),
      component: (
        // showUploadedDocumentsAdmin
        <UploadedDocumentsAdmin
          initiallyUploadedDocuments={documents}
          docsPerKind={documentsFiltered}
          status={applicationData?.[0]?.status}
          id={id}
          disableAll={false
            // applicationData?.[0]?.isService === SERVICE_SIDE ||
            // applicationData?.[0]?.isService === NOONE_SIDE
          }
        />


      ),
    },
    {
      id: 2,
      tabName: t("Referrals"),
      component: (
        <ApplicantReferrals
          key={2}
          id={id}
          flowId={applicationData?.[0]?.status}
          values={formikRef?.current ? formikRef?.current?.values : null}
          viewOnly={viewOnly}
        />
      ),
    },
    {
      id: 3,
      tabName: t("Application History"),
      component: <ApplicationHistory key={3} id={id} />,
    },
    {
      id: 4,
      tabName: t("Print Application Details"),
      component: (
        <PrintApplicationDetails key={4} id={id} data={applicationData?.[0]} />
      ),
    },
    {
      id: 5,
      tabName: t("Gateway Data"),
      component: <GatewayDataDocuments data={applicationData?.[0]} />,
    },
    {
      id: 6,
      tabName: t("eParavolo"),
      component: (
        <EParavoloBackOffice
          data={applicationData?.[0]}
          refetch={refetchApplication}
        />
      ),
    },
  ];

  return (
    <>
      <Helmet title={t("Edit Application")} />
      <Typography variant="h3" gutterBottom display="inline">
        {t("Edit Application")}
      </Typography>

      <Breadcrumbs aria-label="Breadcrumb" mt={2}>
        <Link component={NavLink} exact to="/">
          {t("Dashboard")}
        </Link>
        <Typography>{t("Edit Application")}</Typography>
      </Breadcrumbs>
      <Divider my={6} />
      <CustomAlert
        className={classes.alert}
        open={!!error}
        close={() => {
          setError("");
        }}
        message={error}
      />

      <CustomAlert
        className={classes.alert}
        open={!!success}
        severity="success"
        close={() => {
          setSuccess("");
        }}
        message={success}
      />
      <CustomAlert
        className={classes.alert}
        open={
          applicationData?.[0]?.status === INITIAL_SUBMIT ||
          applicationData?.[0]?.status === RESUBMITTED
        }
        severity="info"
        close={() => {
          setSuccess("");
        }}
        message={t(
          "You need to change the application status to proccess the application"
        )}
      />

      {isLoadingApplication === true ? (
        <div className={classes.loading}>
          <CircularProgress color="primary" />
        </div>
      ) : (
        <div>
          <Formik
            innerRef={formikRef}
            enableReinitialize
            initialValues={{
              available_statuses: null,
              history_comment: "",
              appl_kind_id: applicationData?.[0]?.appl_kind_id,
              applicationKind: applicationData?.[0]?.applicationKind || "",
              port_authority_id: applicationData?.[0]?.port_authority_id,
              portAuthority: applicationData?.[0]?.portAuthority || "",
              portAuthorityApplicant: {
                id: applicationData?.[0]?.port_authority_id,
                dscr: applicationData?.[0]?.portAuthority,
              },
              pickup_place_id: applicationData?.[0]?.pickup_place_id,
              pickup_place:
                PortAuthoritiesData?.find(
                  (item) => item.id === applicationData?.[0]?.pickup_place_id
                ) || "",
              appl_dt:
                dayjs(applicationData?.[0]?.appl_dt).format("DD/MM/YYYY") || "",
              reg_num: applicationData?.[0]?.reg_num || "",
              lname_ait: applicationData?.[0]?.lname_ait || "",
              fname_ait: applicationData?.[0]?.fname_ait || "",
              afm_ait: applicationData?.[0]?.afm_ait || "",
              ind_nr_ait: applicationData?.[0]?.ind_nr_ait || "",
              fath_lname_ait: applicationData?.[0]?.fath_lname_ait || "",
              fath_fname_ait: applicationData?.[0]?.fath_fname_ait || "",
              address_ait: applicationData?.[0]?.address_ait || "",
              address_nr_ait: applicationData?.[0]?.address_nr_ait || "",
              tk_ait: applicationData?.[0]?.tk_ait || "",
              tel_ait: applicationData?.[0]?.tel_ait || "",
              mobile_ait: applicationData?.[0]?.mobile_ait || "",
              email_ait: applicationData?.[0]?.email_ait || "",
              lname_afora: applicationData?.[0]?.lname_afora || "",
              fname_afora: applicationData?.[0]?.fname_afora || "",
              afm_afora: applicationData?.[0]?.afm_afora || "",
              ind_nr_afora: applicationData?.[0]?.ind_nr_afora || "",
              fath_lname_afora: applicationData?.[0]?.fath_lname_afora || "",
              fath_fname_afora: applicationData?.[0]?.fath_fname_afora || "",
              moth_lname_afora: applicationData?.[0]?.moth_lname_afora || "",
              moth_fname_afora: applicationData?.[0]?.moth_fname_afora || "",
              dt_birth_afora: applicationData?.[0]?.dt_birth_afora
                ? new Date(applicationData?.[0]?.dt_birth_afora)
                : null,
              place_birth_afora:
                prfcsData?.find(
                  (item) => item.id === applicationData?.[0]?.place_birth_afora
                ) || "",
              dimos_diamonis_afora:
                prfcsData?.find(
                  (item) =>
                    item.id == applicationData?.[0]?.dimos_diamonis_afora
                ) || "",
              topos_eggrafis_dimotologiou_ellada:
                applicationData?.[0]?.topos_eggrafis_dimotologiou_ellada || "",
              address_afora: applicationData?.[0]?.address_afora || "",
              address_nr_afora: applicationData?.[0]?.address_nr_afora || "",
              tk_afora: applicationData?.[0]?.tk_afora || "",
              tel_afora: applicationData?.[0]?.tel_afora || "",
              mobile_afora: applicationData?.[0]?.mobile_afora || "",
              email_afora: applicationData?.[0]?.email_afora || "",
              currentStatus: applicationData?.[0]?.status,
              rndv_from: applicationData?.[0]?.rndv_from,
              rndv_to: applicationData?.[0]?.rndv_to,
              amka_ait: applicationData?.[0]?.amka_ait,
              meth_ait: applicationData?.[0]?.meth_ait,
              amka_afora: applicationData?.[0]?.amka_afora,
              meth_afora: applicationData?.[0]?.meth_afora,
              a_medical_date: applicationData?.[0]?.a_medical_date,
              b_medical_date: applicationData?.[0]?.b_medical_date,
              sector_id: applicationData?.[0]?.sector_id,
              sector: {
                id: applicationData?.[0]?.sector_id,
                dscr: applicationData?.[0]?.sector,
              },
              epipedo_ekpaideusis_afora: TranslatedEducationLevel?.find(
                (option) =>
                  option.id == applicationData?.[0]?.epipedo_ekpaideusis_afora
              ),
              sintaksiouxos_afora: applicationData?.[0]?.sintaksiouxos_afora
                ? applicationData?.[0]?.sintaksiouxos_afora.toString()
                : null,
              gender_afora: translatedGender?.find(
                (option) => option.id == applicationData?.[0]?.gender_afora
              ),
              nationality_afora: applicationData?.[0]?.nationality_afora,
              reason_for_copy_nautical_issue: applicationData?.[0]
                ?.reason_for_copy_nautical_issue
                ? applicationData?.[0]?.reason_for_copy_nautical_issue.toString()
                : null,
              didactic_year: applicationData?.[0]?.didacticYear || null,
              nauticalPdColor: applicationData?.[0]?.nautical_pd_color,
              read_dilosi_idiotiton:
                applicationData?.[0]?.read_dilosi_idiotiton || null,
              birth_country:
                fetchBirthCountries?.find(
                  (item) => item.id === applicationData?.[0]?.birth_country_id
                ) || " ",
              birth_city_not_greece:
                applicationData?.[0]?.birth_city_not_greece || null,
            }}
            onSubmit={(values, actions) => {
              if (
                values.available_statuses.to_sts_id ===
                APPROVED_AWAITING_COLLECTION &&
                values.rndv_from === null
              ) {
                setIsAppointmentModalOpen(true);
              } else if (
                values.available_statuses.to_sts_id === REJECTED_FROM_SERVICE
              ) {
                setIsRejectionModalOpen(true);
              } else if (
                values.currentStatus === AWAITING_A_MEDICAL_REPORT &&
                (values.available_statuses.to_sts_id === BEING_EDITED ||
                  values.available_statuses.to_sts_id ===
                  MEDICAL_A_DEGREE_REJECTION) &&
                values.a_medical_date === null
              ) {
                setisMedicalAReportOpen(true);
              } else if (
                values.currentStatus === AWAITING_B_MEDICAL_REPORT &&
                (values.available_statuses.to_sts_id ===
                  ISSUING_NAUTICAL_PAPER_PURCHASE_REFERRAL_BLUE ||
                  values.available_statuses.to_sts_id ===
                  ISSUING_NAUTICAL_PAPER_PURCHASE_REFERRAL_YELLOW ||
                  values.available_statuses.to_sts_id ===
                  ISSUING_NAUTICAL_PAPER_PURCHASE_REFERRAL_RED) &&
                values.b_medical_date === null
              ) {
                setisMedicalBReportOpen(true);
              } else if (
                (values.available_statuses.to_sts_id ===
                  ISSUING_NAUTICAL_PAPER_PURCHASE_REFERRAL_BLUE ||
                  values.available_statuses.to_sts_id ===
                  ISSUING_NAUTICAL_PAPER_PURCHASE_REFERRAL_YELLOW ||
                  values.available_statuses.to_sts_id ===
                  ISSUING_NAUTICAL_PAPER_PURCHASE_REFERRAL_RED) &&
                values.sector_id === null
              ) {
                setIsSectorModalOpen(true);
              } else {
                updateApplicationStatus(values, actions);
                actions.setSubmitting(false);
              }

              actions.setSubmitting(false);
            }}
          >
            {({
              submitForm,
              isSubmitting,
              setFieldValue,
              touched,
              errors,
              values,
              resetForm,
            }) => (
              <Form>
                {/* {// console.log(errors)} */}
                <div>
                  <GovGrCard>
                    <Grid container spacing={2}>
                      <Grid item xs={12} sm={12} md={6} lg={6} xl={4}>
                        <div className={classes.insideContentMargin}>
                          <Typography variant="subtitle2" color="textSecondary">
                            {t("Application kind")}
                          </Typography>
                          <Typography variant="h3" gutterBottom>
                            {applicationData?.[0]?.applicationKind || "-"}
                          </Typography>
                        </div>
                      </Grid>
                      <Grid item xs={12} sm={12} md={6} lg={6} xl={4}>
                        <div className={classes.insideContentMargin}>
                          <Typography variant="subtitle2" color="textSecondary">
                            {t("Application current status")}
                          </Typography>
                          <Typography variant="h3" gutterBottom>
                            {applicationData?.[0]?.applicationStatus || "-"}
                          </Typography>
                        </div>
                      </Grid>
                      <Grid item xs={12} sm={12} md={6} lg={6} xl={4}>
                        <div className={classes.insideContentMargin}>
                          <Typography variant="subtitle2" color="textSecondary">
                            {t("Application date")}
                          </Typography>
                          <Typography variant="h3" gutterBottom>
                            {dayjs(applicationData?.[0]?.appl_dt).format(
                              "DD/MM/YYYY"
                            ) || "-"}
                          </Typography>
                        </div>
                      </Grid>
                      <Grid item xs={12} sm={12} md={6} lg={6} xl={4}>
                        <Typography variant="subtitle2" color="textSecondary">
                          {t("Application Protocol Number")}
                        </Typography>
                        <Typography variant="h3" gutterBottom>
                          {applicationData?.[0]?.reg_num || "-"}
                        </Typography>
                      </Grid>
                      <Grid item xs={12} sm={12} md={6} lg={6} xl={4}>
                        <div className={classes.insideContentMargin}>
                          <Typography variant="subtitle2" color="textSecondary">
                            {t("Last comments")}
                          </Typography>
                          <Typography variant="h3" gutterBottom>
                            {commentHistoryData?.[0]?.comments || "-"}
                          </Typography>
                        </div>
                      </Grid>
                    </Grid>
                  </GovGrCard>
                  {applicationData?.[0].status ===
                    APPROVED_AWAITING_COLLECTION ? (
                    <GovGrCard>
                      <div>
                        <Typography variant="subtitle2" color="textSecondary">
                          {t("Appointment date")}
                        </Typography>
                        <Typography variant="h3" gutterBottom>
                          {`${t("From")} ` +
                            dayjs(applicationData?.[0]?.rndv_from).format(
                              "DD/MM/YYYY"
                            )}
                        </Typography>
                      </div>
                      <Typography variant="h3" gutterBottom>
                        {t("Waiting retrieval")}
                      </Typography>
                    </GovGrCard>
                  ) : applicationData?.[0].status === FINISHED ? (
                    <GovGrCard>
                      <div>
                        <Typography variant="subtitle2" color="textSecondary">
                          {t("Appointment date")}
                        </Typography>
                        <Typography variant="h3" gutterBottom>
                          {`${t("From")} ` +
                            dayjs(applicationData?.[0]?.rndv_from).format(
                              "DD/MM/YYYY"
                            )}
                        </Typography>
                      </div>
                      <Typography variant="h3" gutterBottom>
                        {t("Delivered")}
                      </Typography>
                    </GovGrCard>
                  ) : null}

                  <GovGrCard>
                    <div className={classes.cardStatus}>
                      <div className={classes.fieldArea}>
                        <GovGrSelectBox
                          disabled={viewOnly || false}
                          name="available_statuses"
                          label={t("Next Status")}
                          options={availableStatusesData || []}
                          optionlabel="toStatus"
                          defaultoptiontext={t("Choose Here")}
                          disabledmessage={t("Field can't be edited")}
                        />
                        <GovGrTextArea
                          disabled={viewOnly || false}
                          variant="outlined"
                          name="history_comment"
                          margin="normal"
                          label={t("Comment")}
                          rows={6}
                        />

                        {/* <Field
                          disabled={viewOnly || false}
                          className={classes.commentInput}
                          name="history_comment"
                          component={FormikTextField}
                          style={{ minWidth: 500, width: 500 }}
                          variant="outlined"
                          multiline
                          margin="normal"
                          rows={5}
                          label={t("Comment")}
                        /> */}
                      </div>
                    </div>
                    <div className={classes.buttonArea}>
                      {/* <GovGrButton
                        disabled={
                          values.currentStatus !== FOR_REJECT ||
                          values.currentStatus === REJECTED_FROM_CITIZEN
                        }
                        onClick={() => setIsRejectionModalOpen(true)}
                        fullWidth
                        variant="link"
                        buttonText={t("Reject application")}
                      /> */}

                      <GovGrButton
                        disabled={viewOnly || false}
                        onClick={() => {
                          if (
                            values?.available_statuses?.length === 0 ||
                            values?.available_statuses === null
                          ) {
                            setError(
                              t(
                                "Please choose a status from available statuses to continue"
                              )
                            );
                          } else {
                            submitForm();
                          }
                        }}
                        fullWidth
                        variant="primary"
                        buttonText={t("Change application status")}
                      />
                    </div>
                  </GovGrCard>
                </div>

                <GovGrTabs
                  inputTable={
                    auth_level === 4
                      ? tabs.filter((t) => t.id === 0 || t.id === 2)
                      : tabs
                  }
                />

                <AppointmentModal
                  open={isAppointmentModalOpen}
                  close={() => setIsAppointmentModalOpen(false)}
                  submit={() => submitForm()}
                  values={values}
                  setFieldValue={setFieldValue}
                />
                <MedicalAReportModal
                  open={isMedicalAReportOpen}
                  close={() => setisMedicalAReportOpen(false)}
                  submit={() => submitForm()}
                  values={values}
                  setFieldValue={setFieldValue}
                />
                <MedicalBReportModal
                  open={isMedicalBReportOpen}
                  close={() => setisMedicalBReportOpen(false)}
                  submit={() => submitForm()}
                  values={values}
                  setFieldValue={setFieldValue}
                />
                <SectorModal
                  open={isSectorModalOpen}
                  close={() => setIsSectorModalOpen(false)}
                  submit={() => submitForm()}
                  values={values}
                  setFieldValue={setFieldValue}
                />
                <RejectionModal
                  open={isRejectionModalOpen}
                  close={() => setIsRejectionModalOpen(false)}
                  submit={() => rejectApplication(values)}
                  values={values}
                  setFieldValue={setFieldValue}
                />
              </Form>
            )}
          </Formik>
        </div>
      )}
    </>
  );
};

export default ApplicationEditPage;
